globalConfigLoaded(function() {
	'use strict';

	var isWorkbench = false;
	var features = leanStorage.getFromStorage('ls.features');
	if (features) {
		isWorkbench = features['workbench'] != null ? features['workbench'] : globalConfig.defaultFeatures['workbench'];
	} else {
		isWorkbench = globalConfig.defaultFeatures['workbench'];
	}

	var currentCustomerSites = Object.keys(globalConfig.user.authFacts)
	.filter(function(site) {
		return globalConfig.user.authFacts[site].customerNdx === globalConfig.customer.id;
	});

	var hasShortageByOrder = currentCustomerSites.filter(function(site) {
		return globalConfig.user.authFacts[site]['settings'] && globalConfig.user.authFacts[site].settings.ShortageByOrderReport === 'Custom Tabular Report (New)';
	}).length > 0;

	var clearToBuildV1Enabled = currentCustomerSites.filter(
	  	function(site) {
	  		return globalConfig.user.authFacts[site]['settings'] &&
	      globalConfig.user.authFacts[site]['settings']['GenerateClearToBuild'] === '1';
	  	}).length > 0;

	var clearToBuildV2Enabled = currentCustomerSites.filter(
	  	function(site) {
	  		return globalConfig.user.authFacts[site]['settings'] &&
	      globalConfig.user.authFacts[site]['settings']['GenerateClearToBuildFlattenedReqs'] === '1';
	  	}).length > 0;

	angular
		.module('app.setup')
		.constant('UPDATE_TARGETS', {
			// Wanted to put more in here but because of the renderer
			// I couldn't think of a way for it to make a connection
			// without being in the controller.
			'DOUBLE_HEADERS_TOP': [{
				'id': 'fiscalYear',
				'display': 'FiscalYear',
				'class': 'fiscalYearCell alignCenter veryLargeTitle',
				'forceWidth': 2000,
				'rowspan': 1,
				'active': false,
				'title': '',
				'sort': false,
				'colspan': 11
			}]
		});

	angular
		.module('app.leanProjects')
		.constant('X_MATRIX', {
			'imageCirclePath': '/application/library/ui_images/xmatrix/circle.png',
			'imageXMatrixPath': '/application/library/ui_images/xmatrix/200x200.png',
			'noDataMessage': 'There are no projects for this filter combination. Please change your filters.'
		}).constant('ASSESSMENTS', {
			allowedCustomers: [257, 159, 34, 209, 113]
		});

	var VIEW_MAPPINGS = {
		'burnoff': {
			'InventoryBurnoff': {
				'sref': 'app.supply-chain.inventory-burnoff',
				'auth': ['supplyChain', 'analytics', 'inventoryBurnoff']
			}
		},
		'clearToBuild': {
			'clear-to-build/single-level':{
				'sref': 'app.supply-chain.clear-to-build/single-level',
				'auth': ['supplyChain', 'analytics', 'clearToBuild']
			},
			'clear-to-build/multi-level':{
				'sref': 'app.supply-chain.clear-to-build/multi-level',
				'auth': ['supplyChain', 'analytics', 'clearToBuild']
			}
		},
		'buyerWorkbench': {
			'buyer-workbench/by-supplier':{
				'sref': 'app.my-work.buyer-workbench/by-supplier',
				'auth': ['supplyChain', 'workbench']
			},
			'buyer-workbench/all':{
				'sref': 'app.my-work.buyer-workbench/all',
				'auth': ['supplyChain', 'workbench']
			}
		},
		'summaryWorkbench': {
			'summary-workbench':{
				'sref': 'app.my-work.summary-workbench',
				'auth': ['supplyChain', 'workbench']
			},
			'summary-workbench/buyer/by-buyer':{
				'sref': 'app.my-work.summary-workbench/buyer/by-buyer',
				'auth': ['supplyChain', 'workbench']
			},
			'summary-workbench/buyer/all':{
				'sref': 'app.my-work.summary-workbench/buyer/all',
				'auth': ['supplyChain', 'workbench']
			},
			'summary-workbench/supplier/by-supplier':{
				'sref': 'app.my-work.summary-workbench/supplier/by-supplier',
				'auth': ['supplyChain', 'workbench']
			},
			'summary-workbench/supplier/all':{
				'sref': 'app.my-work.summary-workbench/supplier/all',
				'auth': ['supplyChain', 'workbench']
			},
			'summary-workbench/supervisor/all':{
				'sref': 'app.my-work.summary-workbench/supervisor/all',
				'auth': ['supplyChain', 'workbench']
			}
		},
		'user-achievements': {
			'user-achievements/board': {
				'sref': 'app.user-achievements.board',
				'auth': []
			}
		},
		'item-master-data' : {
			'item-master-data-report': {
				'sref': 'app.supply-chain.item-master-data-report',
				'auth': ['supplyChain', 'analytics', 'itemMasterData']
			}
		},
		'opportunities': {
			'inventory-opportunities/pfep-all-items': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-all-items',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'targetSavings']
			},
			'inventory-opportunities/pfep-reorder-point-resizing': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-reorder-point-resizing',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'reorderPointResizing']
			},
			'inventory-opportunities/pfep-safety-stock-optimization': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-safety-stock-optimization',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'safetyStockOptimization']
			},
			'inventory-opportunities/pfep-order-policy-optimization': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-order-policy-optimization',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'orderPolicyOptimization']
			},
			'inventory-opportunities/pfep-min-max-resizing': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-min-max-resizing',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'minMaxResizing']
			},
			'inventory-opportunities/pfep-mrp-resizing': {
				'sref': 'app.supply-chain.inventory-opportunities/pfep-mrp-resizing',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'mrpResizing']
			},
			'inventory-level-over-minmax-max': {
				'sref': 'app.supply-chain.inventory-level-over-minmax-max',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'inventoryLevelOverVmiMax']
			},
			'inventory-opportunities/weekly-inventory-change': {
				'sref': 'app.supply-chain.inventory-opportunities/weekly-inventory-change',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'weeklyInventoryChange']
			},
			'inventory-opportunities/excess-and-obsolete-inventory': {
				'sref': 'app.supply-chain.inventory-opportunities/excess-and-obsolete-inventory',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'excessInventory']
			},
			'inventory-opportunities/purchase-orders-to-cancel': {
				'sref': 'app.supply-chain.inventory-opportunities/purchase-orders-to-cancel',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'purchaseOrdersToCancel']
			},
			'inventory-opportunities/next-90-days': {
				'sref': 'app.supply-chain.inventory-opportunities/next-90-days',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'posToActionNext90Days']
			},
			'excess-inventory-over-lead-time-multiple': {
				'sref': 'app.supply-chain.excess-inventory-over-lead-time-multiple',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'excessInventoryOverLeadTimeMultiple']
			},
			'excess-to-transfer': {
				'sref': 'app.supply-chain.excess-to-transfer',
				'auth': ['supplyChain', 'analytics', 'crossProjectExcess']
			},
			'pos-for-excess-over-lead-time-multiple': {
				'sref': 'app.supply-chain.pos-for-excess-over-lead-time-multiple',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'posForExcessOverLeadTimeMultiple']
			},
			'reorder-point-items-over-max': {
				'sref': 'app.supply-chain.reorder-point-items-over-max',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'ropItemsOverMax']
			}
		},
		'supplier': {
			'supplier-on-hand-inventory': {
				'sref': 'app.supply-chain.supplier-on-hand-inventory',
				'auth': ['supplyChain', 'analytics', 'inventoryOpportunities', 'supplierOnHandInventory']
			}
		},
		'manufacturedOpportunities': {
			'ManufacturedOpportunitiesBySavings': {
				'sref': 'app.supply-chain.pfep-all-finished-goods',
				'auth': ['supplyChain', 'analytics', 'manufacturedOpportunities']
			}
		},
		'shortages': {
			'material-shortages/shortages-by-item': {
				'sref': 'app.supply-chain.material-shortages/shortages-by-item',
				'auth': ['supplyChain', 'analytics', 'shortages', 'shortageByItem']
			},
			'material-shortages/demand-simulation': {
				'sref': 'app.supply-chain.material-shortages/demand-simulation',
				'auth': ['supplyChain', 'analytics', 'shortages', 'shortageByItem']
			},
			'material-shortages/shortages-by-order': {
				'sref': 'app.supply-chain.material-shortages/shortages-by-order',
				'auth': ['supplyChain', 'analytics', 'shortages', 'shortageByOrder']
			},
			'material-shortages/minmax-items-under-min': {
				'sref': 'app.supply-chain.material-shortages/minmax-items-under-min',
				'auth': ['supplyChain', 'analytics', 'shortages', 'minmaxUnderMin']
			},
			'material-shortages/items-under-safety-stock': {
				'sref': 'app.supply-chain.material-shortages/items-under-safety-stock',
				'auth': ['supplyChain', 'analytics', 'shortages', 'underSafetyStock']
			}
		},
		'purchase-reqs': {
			'PurchaseReqsInsideLeadTime': {
				'sref': 'app.supply-chain.purchase-requisitions',
				'auth': ['supplyChain', 'purchaseRequisitions']
			}
		},
		'tasks': {
			'ProcurementTasks': {
				'sref': 'app.supply-chain.procurement-tasks',
				'auth': ['supplyChain', 'analytics', 'procurementTasks']
			}
		},
		'lob': {
			'line-of-balance/all-parts': {
				'sref': 'app.supply-chain.line-of-balance/all-parts',
				'auth': ['supplyChain', 'analytics', 'lineOfBalance']
			},
			'line-of-balance/end-item': {
				'sref': 'app.supply-chain.line-of-balance/end-item',
				'auth': ['supplyChain', 'analytics', 'lineOfBalance', 'clearToBuild']
			}
		},
		'supplierperf': {
			'performance-summary/last-month-performance': {
				'sref': 'app.supply-chain.performance-summary/last-month-performance',
				'auth': ['supplyChain', 'supplierPerformance', 'supplierPerformanceSummary']
			},
			'performance-summary/rolling-average-performance': {
				'sref': 'app.supply-chain.performance-summary/rolling-average-performance',
				'auth': ['supplyChain', 'supplierPerformance', 'supplierPerformanceSummary']
			}
		},
		'scorecard': {
			'SupplierScorecard': {
				'sref': 'app.supply-chain.scorecard',
				'auth': ['supplyChain', 'supplierPerformance', 'scorecard']
			}
		},
		'spendsummary': {
			'spend-summary/supplier-spend': {
				'sref': 'app.supply-chain.spend-summary/supplier-spend',
				'auth': ['supplyChain', 'spend', 'spendSummary', 'supplierSpend']
			},
			'spend-summary/material-group-spend': {
				'sref': 'app.supply-chain.spend-summary/material-group-spend',
				'auth': ['supplyChain', 'spend', 'spendSummary', 'materialGroupSpend']
			},
			'spend-summary/item-group-spend': {
				'sref': 'app.supply-chain.spend-summary/item-group-spend',
				'auth': ['supplyChain', 'spend', 'spendSummary', 'itemGroupSpend']
			}
		},
		'spendanalytics': {
			'spend-analytics/supplier-spend': {
				'sref': 'app.supply-chain.spend-analytics/supplier-spend',
				'auth': ['supplyChain', 'spend', 'spendAnalytics', 'supplierSpend']
			},
			'spend-analytics/item-spend': {
				'sref': 'app.supply-chain.spend-analytics/item-spend',
				'auth': ['supplyChain', 'spend', 'spendAnalytics', 'itemSpend']
			}
		},
		'requirements': {
			'requirements/raw-requirements': {
				'sref': 'app.supply-chain.requirements/raw-requirements',
				'auth': ['supplyChain', 'reports', 'requirements', 'rawRequirements']
			},
			'requirements/weekly-requirements': {
				'sref': 'app.supply-chain.requirements/weekly-requirements',
				'auth': ['supplyChain', 'reports', 'requirements', 'weeklyRequirements']
			}
		},
		'inventory': {
			'inventory/purchased-inventory': {
				'sref': 'app.supply-chain.inventory/purchased-inventory',
				'auth': ['supplyChain', 'reports', 'inventory', 'purchasedInventory']
			},
			'inventory/manufactured-inventory': {
				'sref': 'app.supply-chain.inventory/manufactured-inventory',
				'auth': ['supplyChain', 'reports', 'inventory', 'manufacturedInventory']
			}
		},
		'purchaseorders': {
			'purchase-orders': {
				'sref': 'app.supply-chain.purchase-orders',
				'auth': ['supplyChain', 'purchaseOrders']
			}
		},
		'purchaseorderchanges': {
			'purchase-order-changes': {
				'sref': 'app.supply-chain.purchase-order-changes',
				'auth': ['supplyChain', 'reports', 'purchaseOrderChanges']
			}
		},
		'customerorderchanges': {
			'customer-order-changes': {
				'sref': 'app.supply-chain.customer-order-changes',
				'auth': ['supplyChain', 'reports', 'customerOrderChanges']
			}
		},
		'opencustomerorders': {
			'open-customer-orders': {
				'sref': 'app.supply-chain.open-customer-orders',
				'auth': ['supplyChain', 'reports']
			}
		},
		'indirectpurchaseorders': {
			'IndirectPurchaseOrder': {
				'sref': 'app.supply-chain.indirect-purchase-orders',
				'auth': ['supplyChain', 'reports', 'indirectPurchaseOrders']
			}
		},
		'purchaseorderreceipts': {
			'purchase-order-receipts': {
				'sref': 'app.supply-chain.purchase-order-receipts',
				'auth': ['supplyChain', 'purchaseOrderReceipts']
			}
		},
		'purchaseorderconfirmations': {
			'purchase-order-confirmations': {
				'sref': 'app.supply-chain.purchase-order-confirmations',
				'auth': ['supplyChain', 'purchaseOrderConfirmations']
			}
		},
		'orders': {
			'Order': {
				'sref': 'app.supply-chain.orders',
				'auth': ['supplyChain', 'reports', 'orders']
			}
		},
		'pastRequirements': {
			'PastRequirements': {
				'sref': 'app.supply-chain.past-requirements',
				'auth': ['supplyChain', 'reports', 'pastRequirements']
			}
		},
		'procurementhistory': {
			'ProcurementHistory': {
				'sref': 'app.supply-chain.procurement-history',
				'auth': ['supplyChain', 'reports', 'procurementHistory']
			}
		},
		'supplierquality': {
			'SupplierQuality': {
				'sref': 'supplierquality.results',
				'auth': ['supplyChain', 'supplierPerformance', 'supplierQuality']
			}
		},
		'itemsearch': {
			'ItemSearch': {
				'sref': 'app.supply-chain.item-search',
				'auth': ['supplyChain', 'itemSearch']
			}
		},
		'reportcard': {
			'report-card': {
				'sref': 'app.leanProjects.report-card',
				'auth': ['factory', 'valueStream', 'reportCard']
			},
			'ValueStreamReportCard': {
				'sref': 'app.leanProjects.report-card',
				'auth': ['factory', 'valueStream', 'reportCard']
			}
		},
		'viewMetricData': {
			'ViewMetricData': {
				'sref': 'app.lean-projects.metric-view',
				'auth': ['leanProjects', 'metrics', 'viewData']
			}
		},
		'updatetargets': {
			'update-targets': {
				'sref': 'app.setup.updateTargets',
				'auth': ['admin']
			},
			'update-weekly-targets': {
				'sref': 'app.setup.updateWeeklyTargets',
				'auth': ['admin']
			}
		},
		'projects-updatetargets': {
			'update-targets': {
				'sref': 'app.lean-projects.update-targets',
				'auth': ['admin']
			},
			'update-weekly-targets': {
				'sref': 'app.lean-projects.update-weekly-targets',
				'auth': ['admin']
			}
		},
		'potoaction12months': {
			'POsToActionNext12Months': {
				'sref': 'app.supply-chain.pos-to-action-report',
				'auth': ['supplyChain', 'reports', 'potoaction12months']
			}
		},
		'procurementAnalysis': {
			'pq-analysis/pq-by-cost': {
				'sref': 'app.supply-chain.pq-analysis/pq-by-cost',
				'auth': ['supplyChain', 'reports']
			},
			'pq-analysis/abc-analysis': {
				'sref': 'app.supply-chain.pq-analysis/abc-analysis',
				'auth': ['supplyChain', 'reports']
			}
		},
		'workbench': {
			'workbench': {
				'sref': 'app.supply-chain.workbench',
				'auth': ['supplyChain', 'workbench']
			}
		},
		'dataPipeline': {
			'DataPipelineStatusSummary': {
				'sref': 'app.setup.data-pipeline',
				'auth': ['setup', 'dataPipeline']
			}
		},
		'dashboards': {
			'allDashboards': {
				'auth': ['dashboard']
			}
		},
		'performance': {
			'buyer-performance': {
				'auth': ['dashboard']
			},
			'site-performance': {
				'auth': ['dashboard']
			},
			'planner-performance-single-level': {
				'auth': ['clearToBuild', 'dashboard']
			},
			'planner-performance-multi-level': {
				'auth': ['clearToBuild', 'dashboard']
			},
			'item-group-performance': {
				'auth': ['dashboard']
			}
		}
	};

	var SUPPLIER_VIEWS = [
		'workbench',
		'shortages',
		'lob',
		'opportunities',
		'purchase-reqs',
		'purchaseorders',
		'supplierperf',
		'user-achievements',
		'supplier'
	];

	var REPORTSETTINGSNAME_TO_VIEWTYPE = {};
	for (var viewType in VIEW_MAPPINGS) {
		for (var reportSettingsName in VIEW_MAPPINGS[viewType]) {
			REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] = viewType;
		}
	}
	REPORTSETTINGSNAME_TO_VIEWTYPE['UserManagement'] = 'manageUsers';
	REPORTSETTINGSNAME_TO_VIEWTYPE['ManageEmailAlerts'] = 'emailAlerts';
	var environment = globalConfig.environment || 'Unknown';

	angular
		.module('app.core')
		.constant('ENVIRONMENT', {
			CURRENT: environment.toUpperCase(),
			Current: environment,
			PRODUCTION: 'PRODUCTION'
		})
		.constant('URLS', {
			'frontendPrefix': '/application/f/home.html#/',
			'prefix': '2/factndx/',
			'host': '/api/',
			'apiPrefix': '/api/2/factndx/',
			'dashboards': '/api/2/companyId/{0}/Template',
			'switchSite': '/auth/1/authenticate/ldnasession/switchSite/{0}',
			'logout': '/auth/1/logout',
			'projectTeam' : '2/factndx/{0}/LeanProject/{1}/TeamMembers',
			'projectsMetrics' : '2/factndx/{0}/LeanProject/{1}/Metrics',
			'valueStreamsForMetric' : '2/factndx/{0}/LeanProject/{1}/Metric/{2}/ValueStreams',
			'deleteMember' : '2/factndx/{0}/LeanProject/{1}/TeamMember/',
			'editMetric' : '2/factndx/{0}/LeanProject/{1}/Metric/',
			'deleteMetric' : '2/factndx/{0}/LeanProject/{1}/Metric/{2}/ValueStream/{3}',
			'widgetMetrics' : '2/factndx/{0}/Metrics',
			'metricResults' : '2/factndx/{0}/Metric/{1}/MetricResults',
			'allMetricResults' : '2/factndx/{0}/MetricResults',
			'usersNotInProject' : '2/factndx/{0}/LeanProject/{1}/UnusedUsers',
			'lastModifiedForProject': '2/factndx/{0}/LeanProject/{1}/LastModified',
			'requirements': '{0}/RequirementsReport',
			'viewTasks': '{0}/LeanProjects/ViewTasks',
			'userSearch':'2/User/Search?limit=20&userSearch={0}',
			'taskWatcher': '2/factndx/{0}/Actions/Watcher',
			'taskWatcherDelete': '2/factndx/{0}/Actions/Watcher/{1}/{2}',
			'responsibleCategories':'2/factndx/{0}/Comment/ResponsibleCategories',
			'siblingSites': '2/factndx/{0}/SiblingSites',
			'viewMetrics': '2/factndx/{0}/Metrics/View',
			'cloneMetric': '2/factndx/{0}/CloneMetric/{1}/Owner/{2}',
			'cloneValueStreamMetrics': '2/factndx/{0}/CloneValueStreamMetrics',
			'metricCategories':'2/factndx/{0}/ControlTower/Categories',
			'allMetricCategories': '2/factndx/{0}/ControlTower/AllCategories',
			'controlTowerData': '2/factndx/{0}/ControlTower/Data',
			'metricTypes':'2/factndx/{0}/ControlTower/Types',
			'factoryGoals': '2/factndx/{0}/StrategicGoals',
			'goalsCrud': '2/factndx/{0}/StrategicGoals',
			'inventoryActionTypes': '2/InventoryActionTypes',
			'inventoryActionConfigurations': '2/factndx/{0}/InventoryActionConfigurations',
			'inventoryActionConfigurationsState': '2/factndx/{0}/InventoryActionConfigurationsState',
			'inventoryActionDefaultResponsible': '2/factndx/{0}/InventoryActionDefaultResponsible',
			'inventoryActionExcessToSellDefaultResponsible': '2/factndx/{0}/InventoryActionExcessToSellDefaultResponsible',
			'inventoryActionUnableToFixCategory': '2/factndx/{0}/InventoryActionUnableToFixCategory',
			'InventoryActionUnableToFixCategories': '2/factndx/{0}/InventoryActionUnableToFixCategories',
			'inventoryActionBlackListSites': '2/factndx/{0}/InventoryActionBlackListSites',
			'inventoryActionValidSavings': '2/factndx/{0}/InventoryActions/ValidSavings',
			'inventoryReport': '{0}/InventoryReport',
			'excelKpiUserReport': '2/factndx/{0}/KpiUsersReport',
			'abcAnalysisReport': '2/factndx/{0}/PurchasedInventoryByABCClassificationReport',
			'reportCardParameters': '2/factndx/{0}/ReportCardParameters',
			'reportCardParameter': '2/factndx/{0}/ReportCardParameter',
			'factoryValueStreams': '2/factndx/{0}/FactoryValueStreams',
			'factoryValueStream': '2/factndx/{0}/FactoryValueStream',
			'factoryAssessment': '2/factndx/{0}/Assessments',
			'inventoryActionStatus': '2/factndx/{0}/InventoryActionHistory',
			'inventoryActionUnableToFixValuePareto': '2/factndx/{0}/InventoryActionUnableToFixValuePareto',
			'InventoryActionHistory': '2/factndx/{0}/InventoryActionHistory/itemId/{1}',
			'noFactoryPrefix': '/api/2/',
			'projectYtdSavings': '2/factndx/{0}/LeanProject/{1}/YtdSavings',
			'userAttributes': '2/UserAttributes',
			'emailNotification': '2/Email/Notification',
			'projectInitiatives':'2/factndx/{0}/Initiatives',
			'projectAreas': '2/Dimensions/factndx/{0}/LeanProjects/Areas',
			'projectCategories': '2/Dimensions/factndx/{0}/LeanProjects/Categories',
			'allMetrics' : '2/Dimensions/factndx/{0}/MetricsDropdown',
			'itemGroups':'2/Dimensions/factndx/{0}/ItemGroups',
			'buyers': '2/Dimensions/factndx/{0}/Buyers',
			'globalSuppliers': '2/Dimensions/factndx/{0}/GlobalSuppliers',
			'endItems': '2/Dimensions/factndx/{0}/EndItems',
			'inventoryActionReportingPeriod': '2/Dimensions/factndx/{0}/InventoryActionReportingPeriod',
			'suppliers':'2/Dimensions/factndx/{0}/Suppliers',
			'suppliersForInitiative':'2/Dimensions/factndx/{0}/SuppliersForInitiative',
			'erpOrderPolicies':'2/Dimensions/factndx/{0}/ErpOrderPolicies',
			'abcClasses':'2/Dimensions/factndx/{0}/AbcClasses',
			'erpDocumentTypes':'2/Dimensions/factndx/{0}/ErpDocumentTypes',
			'erpStatuses':'2/Dimensions/factndx/{0}/ErpStatuses',
			'exceptionMessages':'2/Dimensions/factndx/{0}/ExceptionMessages',
			'orderPolicies':'2/Dimensions/factndx/{0}/OrderPolicies',
			'searchItemCodes':'2/factndx/{0}/ItemSearch',
			'supplierSearch':'2/Dimensions/factndx/{0}/SupplierSearch?limit=20&supplierSearch={1}',
			'shipsets':'2/Dimensions/factndx/{0}/Orders',
			'orderNumbersWithShortage':'2/Dimensions/factndx/{0}/OrderNumbersWithShortage',
			'locationsWithShortage':'2/Dimensions/factndx/{0}/LocationsWithShortage',
			'familyGroups':'2/Dimensions/factndx/{0}/FamilyGroups',
			'sboRequirementTypes':'2/Dimensions/factndx/{0}/SBORequirementTypes',
			'sboOperationsNumbers':'2/Dimensions/factndx/{0}/SBOOperationsNumbers',
			'sboWorkcenters':'2/Dimensions/factndx/{0}/SBOWorkcenters',
			'purchaseDocumentTypes':'2/Dimensions/factndx/{0}/PurchaseDocumentTypes',
			'riskCategories':'2/Dimensions/factndx/{0}/RiskCategories',
			'riskLevels':'2/Dimensions/factndx/{0}/RiskLevels',
			'indirectSpendCategories':'2/Dimensions/factndx/{0}/IndirectSpendCategories',
			'associatedSpendItemCodes':'2/Dimensions/factndx/{0}/AssociatedSpendItemCodes',
			'materialGroups':'2/Dimensions/factndx/{0}/MaterialGroups',
			'materialTypes':'2/Dimensions/factndx/{0}/MaterialTypes',
			'mrpElements':'2/Dimensions/factndx/{0}/MrpElements',
			'storageTypes':'2/Dimensions/factndx/{0}/StorageTypes',
			'responsibleUsers':'2/Dimensions/factndx/{0}/ResponsibleUsers',
			'taskStatuses':'2/Dimensions/factndx/{0}/TaskStatus',
			'taskCategories':'2/Dimensions/factndx/{0}/TaskCategory',
			'planners':'2/Dimensions/factndx/{0}/Planners',
			'factories':'2/Dimensions/Factories',
			'allFactories':'2/Dimensions/AllFactories',
			'allCustomerFactories':'2/Dimensions/AllCustomerFactories',
			'allFactoryTypes':'2/Dimensions/AllFactoryTypes',
			'multiFactory':'2/Dimensions/factndx/{0}/MultiFactoryOptions',
			'roles':'2/Dimensions/Roles',
			'profileTypes':'2/Dimensions/ProfileTypes',
			'startMonths':'2/Dimensions/factndx/{0}/StartMonths',
			'criticalIndicators':'2/Dimensions/factndx/{0}/CriticalIndicator',
			'entities':'2/Dimensions/factndx/{0}/FactoryHierarchy/Field/Entity',
			'divisions':'2/Dimensions/factndx/{0}/FactoryHierarchy/Field/Division',
			'businessUnits':'2/Dimensions/factndx/{0}/FactoryHierarchy/Field/BusinessUnit',
			'regions':'2/Dimensions/factndx/{0}/FactoryHierarchy/Field/Region',
			'metricOwners':'2/Dimensions/factndx/{0}/MetricOwners',
			'valueStreams':'2/Dimensions/factndx/{0}/ValueStreams',
			'valueStreamsWithPerf': '2/Dimensions/factndx/{0}/ValueStreamsWithPerf',
			'fiscalYears':'2/Dimensions/factndx/{0}/FiscalYearList',
			'usersForSite': '2/Dimensions/factndx/{0}/FactoryUsers?excludeSupplier={1}',
			'projectStages':'2/Dimensions/factndx/{0}/LeanProjects/Stages',
			'projectStagesBySite': '2/Dimensions/factndx/{0}/LeanProjects/StagesBySites',
			'projectTypes':'2/Dimensions/factndx/{0}/LeanProjects/Types',
			'projectManagers':'2/Dimensions/factndx/{0}/LeanProjects/Managers',
			'projectGoals': '2/Dimensions/factndx/{0}/LeanProjects/Goals',
			'goals': '2/Dimensions/factndx/{0}/Goals',
			'shifts':'2/Dimensions/factndx/{0}/Shifts',
			'inventoryActionUnableToFixCategories': '2/Dimensions/factndx/{0}/InventoryActionUnableToFixCategories',
			'procurementTaskCategories': '2/factndx/{0}/ProcurementTaskCategories',
			'sitesByCustomerNoPilot': '2/Dimensions/factndx/{0}/Sites/Customer/{1}?noPilot=true',
			'specialProcurementTypes': '2/Dimensions/factndx/{0}/SpecialProcurementType',
			'responsibleCommitDateChange': '2/Dimensions/factndx/{0}/ResponsibleShortageCommitDateChange',
			'customerSuccessCustomers': '2/Dimensions/factndx/{0}/CustomerSuccessCustomers',
			'actionStatuses': '2/Dimensions/factndx/{0}/ActionStatus',
			'metricsInfo': '2/factndx/{0}/MetricInfo',
			'myCurrentShortages': '2/factndx/{0}/BuyerStandardWork/MyCurrentShortages',
			'myPRsToFirm': '2/factndx/{0}/BuyerStandardWork/MyPRsToFirm',
			'shortageCriticalityLevels': '2/Dimensions/factndx/{0}/ShortageCriticalityLevels',
			'supplierLateDeliveryIssues': '{0}/SupplierLateDeliveryIssues',
			'lateDeliveryIssue': '2/factndx/{0}/SupplierLateDeliveryIssue',
			'lateDeliveryCausesByLiability':'2/Dimensions/factndx/{0}/LateDeliveryCausesByLiability',
			'poStatusCategoriesDimension': '2/Dimensions/companyId/{0}/PoStatusCategories',
			'poStatusCategories': '2/companyId/{0}/PoStatusCategories',
			'poStatusCategoriesReportUrl': 'companyId/{0}/PoStatusCategories',
			'customerOrderStatusCategories': '2/companyId/{0}/CustomerOrderStatusCategories',
			'customerOrderStatusCategoriesReportUrl': 'companyId/{0}/CustomerOrderStatusCategories',
			'supplierLateDelivery':'2/Dimensions/factndx/{0}/SupplierLateDelivery',
			'supplyOrderForecast': '2/factndx/{0}/SupplyOrder/{1}/Forecasts',
			'poRecommendations': '2/factndx/{0}/PORecommendations',
			'iaStatusedPoRecs': '2/factndx/{0}/IAStatusedPoRecs',
			'shortagePoActions': '2/factndx/{0}/ShortagePoActions',
			'allEmailTags': '2/Dimensions/EmailTags',
			'allAuditLogObjectTypes': '2/Dimensions/AuditLogObjectTypes',
			'isUserValidBuyer': '2/factndx/{0}/BuyerStandardWork/Buyer',
			'getSqlSnippetsByType':'2/companyId/{0}/SQLSnippets/type/{1}',
			'projectTypeCrud': '2/factndx/{0}/ProjectType',
			'projectSavingsCategoryCrud': '2/companyId/{0}/LeanProjects/SavingsCategory',
			'projectSavingsCategories': '2/Dimensions/factndx/{0}/ProjectSavingsCategoriesByFactory',
			'getFlexFieldValues': '2/Dimensions/factndx/{0}/FlexFieldValues?field=',
			'projectAreaCrud': '2/factndx/{0}/Area',
			'flexFields': 'companyId/{0}/FlexFields',
			'samlConfigURL': '2/companyId/{0}/samlIdpProfile',
			'metadataSpURL': '/auth/1/saml2/metadata/customer/{0}',
			'supplierAllowedColumns': '2/companyId/{0}/SupplierAllowedColumn',
			'analysisReplenishmentTypes': '2/Dimensions/factndx/{0}/AnalysisReplenishmentTypes',
			'projectCategoryCrud': '2/factndx/{0}/ProjectCategory',
			'deliveryDateStatuses': '2/Dimensions/DeliveryDateStatuses',
			'confirmationStatuses': '2/Dimensions/ConfirmationStatuses',
			'getCustomFieldValues': '2/Dimensions/companyId/{0}/CustomFieldValues?customFieldNdx={1}',
			'getWriteBackActionTypes': '2/Dimensions/WriteBackActionTypeOptions'
		})
		.constant('siteUrl', '/application/')
		.constant('oldNavMargin', 180)
		.constant('oldNavMarginCollapsed', 0)
		// also update style.css if updating this
		.constant('defaultTransitionDuration', 300)
		.constant('oldNavMarginCollapsed', 0)
		.constant('FIRST_VIEW', {
			'DEFAULT_MAP': {
				'dashboards': 'dashboard-navigation',
				'shortages': 'material-shortages/shortages-by-item',
				'clearToBuild': clearToBuildV2Enabled ? 'clear-to-build/multi-level' : 'clear-to-build/single-level',
				'buyerWorkbench': 'buyer-workbench/by-supplier',
				'summaryWorkbench': 'summary-workbench',
				'opportunities': 'inventory-opportunities/pfep-all-items',
				'itemMasterData': 'item-master-data-report',
				'manufacturedOpportunities': 'ManufacturedOpportunitiesBySavings',
				'supplierperf': 'performance-summary/last-month-performance',
				'master': 'requirements/raw-requirements',
				'tasks': 'ProcurementTasks',
				'purchase-reqs': 'PurchaseReqsInsideLeadTime',
				'burnoff': 'InventoryBurnoff',
				'scorecard': 'SupplierScorecard',
				'requirements': 'requirements/raw-requirements',
				'inventory': 'inventory/purchased-inventory',
				'spendsummary': 'spend-summary/supplier-spend',
				'spendanalytics': 'spend-analytics/supplier-spend',
				'supplierquality': 'SupplierQuality',
				'procurementAnalysis': 'pq-analysis/pq-by-cost',
				'dataPipeline': 'DataPipelineStatusSummary',
				'lob': 'line-of-balance/all-parts',
				'endItem': 'line-of-balance/end-item',
				'updatetargets': 'update-targets',
				'projects-updatetargets': 'update-targets',
				'user-achievements': 'user-achievements/board',
				'my-work': isWorkbench ? 'buyer-workbench/all' : 'my-inventory-opportunities'
			},
			'VIEWS': {
				'shortages': [{
					'name': 'Shortages by Item',
					'url': '/application/f/home.html#/supply-chain/material-shortages/shortages-by-item/',
					'display': true,
					'viewMappingsName': 'material-shortages/shortages-by-item'
				}, {
					'name': 'Demand scenario modeling',
					'url': '/application/f/home.html#/supply-chain/material-shortages/demand-simulation/',
					'display': false,
					'viewMappingsName': 'material-shortages/demand-simulation'
				},{
					'name': 'Shortages by Order',
					'url': '/application/f/home.html#/supply-chain/material-shortages/shortages-by-order/',
					'display': hasShortageByOrder,
					'viewMappingsName': 'material-shortages/shortages-by-order'
				}, {
					'name': 'MinMax Items Under Min',
					'url': '/application/f/home.html#/supply-chain/material-shortages/minmax-items-under-min/',
					'display': true,
					'viewMappingsName': 'material-shortages/minmax-items-under-min'
				}, {
					'name': 'Items Under Safety Stock',
					'url': '/application/f/home.html#/supply-chain/material-shortages/items-under-safety-stock/',
					'display': true,
					'viewMappingsName': 'material-shortages/items-under-safety-stock'
				}],
				'lob': [{
					'name': 'Line of Balance: All Parts',
					'url': '/application/f/home.html#/supply-chain/line-of-balance/all-parts/',
					'display': true,
					'viewMappingsName': 'line-of-balance/all-parts'
				}, {
					'name': 'Line of Balance: End Item',
					'url': '/application/f/home.html#/supply-chain/line-of-balance/end-item/',
					'display': true,
					'viewMappingsName': 'line-of-balance/end-item'
				}],
				'clearToBuild':
					[{
						'name': 'Clear To Build Single Level',
						'url': '/application/f/home.html#/supply-chain/clear-to-build/single-level/',
						'display': clearToBuildV1Enabled,
						'viewMappingsName': 'clear-to-build/single-level'
					}, {
						'name': 'Clear To Build Multi Level',
						'url': '/application/f/home.html#/supply-chain/clear-to-build/multi-level/',
						'display': clearToBuildV2Enabled,
						'viewMappingsName': 'clear-to-build/multi-level'
					}],
				'buyerWorkbench':
					[{
						'name': 'Workbench (by supplier)',
						'url': '/application/f/home.html#/supply-chain/buyer-workbench/by-supplier/',
						'display': true,
						'viewMappingsName': 'buyer-workbench/by-supplier'
					}, {
						'name': 'Workbench (all)',
						'url': '/application/f/home.html#/supply-chain/buyer-workbench/all/',
						'display': true,
						'viewMappingsName': 'buyer-workbench/all'
					}],
				'summaryWorkbench':
					[{
						'name': 'Summary workbench',
						'url': '/application/f/home.html#/my-work/summary-workbench',
						'display': true,
						'viewMappingsName': 'summary-workbench'
					}, {
						'name': 'Buyer summary workbench (by buyer)',
						'url': '/application/f/home.html#/my-work/summary-workbench/buyer/by-buyer/',
						'display': true,
						'viewMappingsName': 'summary-workbench/buyer/by-buyer'
					}, {
						'name': 'Buyer summary workbench (all)',
						'url': '/application/f/home.html#/my-work/summary-workbench/buyer/all/',
						'display': true,
						'viewMappingsName': 'summary-workbench/buyer/all'
					}, {
						'name': 'Supplier summary workbench (by supplier)',
						'url': '/application/f/home.html#/my-work/summary-workbench/supplier/by-supplier/',
						'display': true,
						'viewMappingsName': 'summary-workbench/supplier/by-supplier'
					}, {
						'name': 'Supplier summary workbench (all)',
						'url': '/application/f/home.html#/my-work/summary-workbench/supplier/all/',
						'display': true,
						'viewMappingsName': 'summary-workbench/supplier/all'
					}, {
						'name': 'Supervisor summary workbench (all)',
						'url': '/application/f/home.html#/my-work/summary-workbench/supervisor/all/',
						'display': true,
						'viewMappingsName': 'summary-workbench/supervisor/all'
					}],
				'item-master-data': [{
					'name': 'Item master data',
					'url': '/application/f/home.html#/supply-chain/item-master-data-report/',
					'display': true,
					'viewMappingsName': 'item-master-data-report'
				}],
				'opportunities':
					[{
						'name': 'Plan For Every Part: All Purchased Items',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-all-items/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-all-items'
					}, {
						'name': 'PFEP: Order Policy Optimization',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-order-policy-optimization/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-order-policy-optimization'
					}, {
						'name': 'PFEP: MRP Resizing',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-mrp-resizing/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-mrp-resizing'
					}, {
						'name': 'PFEP: MinMax Resizing',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-min-max-resizing/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-min-max-resizing'
					}, {
						'name': 'PFEP: Safety Stock Optimization',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-safety-stock-optimization/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-safety-stock-optimization'
					}, {
						'name': 'PFEP: Reorder Point Resizing',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/pfep-reorder-point-resizing/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/pfep-reorder-point-resizing'
					}, {
						'name': 'Weekly Inventory Change',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/weekly-inventory-change/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/weekly-inventory-change'
					}, {
						'name': 'Excess & Obsolete Inventory',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/excess-and-obsolete-inventory/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/excess-and-obsolete-inventory'
					}, {
						'name': 'Purchase Orders to Cancel',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/purchase-orders-to-cancel/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/purchase-orders-to-cancel'
					}, {
						'name': 'POs to Action: Next 90 Days',
						'url': '/application/f/home.html#/supply-chain/inventory-opportunities/next-90-days/',
						'display': true,
						'viewMappingsName': 'inventory-opportunities/next-90-days'
					}],
				'requirements': [{
					'name': 'Raw Requirements',
					'url': '/application/f/home.html#/supply-chain/requirements/raw-requirements/',
					'display': true,
					'viewMappingsName': 'requirements/raw-requirements'
				}, {
					'name': 'Weekly Requirements',
					'url': '/application/f/home.html#/supply-chain/requirements/weekly-requirements/',
					'display': true,
					'viewMappingsName': 'requirements/weekly-requirements'
				}],
				'inventory': [{
					'name': 'Purchased Inventory',
					'url': '/application/f/home.html#/supply-chain/inventory/purchased-inventory/',
					'display': true,
					'viewMappingsName': 'inventory/purchased-inventory'
				}, {
					'name': 'Manufactured Inventory',
					'url': '/application/f/home.html#/supply-chain/inventory/manufactured-inventory/',
					'display': true,
					'viewMappingsName': 'inventory/manufactured-inventory'
				}],
				'supplierperf': [{
					'name': 'Last Month Performance',
					'url': '/application/f/home.html#/supply-chain/performance-summary/last-month-performance/',
					'display': true,
					'viewMappingsName': 'performance-summary/last-month-performance'
				}, {
					'name': 'Rolling Average Performance',
					'url': '/application/f/home.html#/supply-chain/performance-summary/rolling-average-performance/',
					'display': true,
					'viewMappingsName': 'performance-summary/rolling-average-performance'
				}],
				'spendsummary': [{
					'name': 'Supplier Spend',
					'url': '/application/f/home.html#/supply-chain/spend-summary/supplier-spend/',
					'display': true,
					'viewMappingsName': 'spend-summary/supplier-spend'
				}, {
					'name': 'Material Group Spend',
					'url': '/application/f/home.html#/supply-chain/spend-summary/material-group-spend/',
					'display': true,
					'viewMappingsName': 'spend-summary/material-group-spend'
				}, {
					'name': 'Item Group Spend',
					'url': '/application/f/home.html#/supply-chain/spend-summary/item-group-spend/',
					'display': true,
					'viewMappingsName': 'spend-summary/item-group-spend'
				}],
				'spendanalytics': [{
					'name': 'Supplier Spend',
					'url': '/application/f/home.html#/supply-chain/spend-analytics/supplier-spend/',
					'display': true,
					'viewMappingsName': 'spend-analytics/supplier-spend'
				}, {
					'name': 'Item Spend',
					'url': '/application/f/home.html#/supply-chain/spend-analytics/item-spend/',
					'display': true,
					'viewMappingsName': 'spend-analytics/item-spend'
				}],
				'reportcard': [{
					'name': 'Report Card',
					'url': '/application/f/home.html#/factory/report-card',
					'display': true,
					'viewMappingsName': 'report-card'
				}, {
					'name': 'Value Stream Report Card',
					'url': '/application/f/home.html#/factory/report-card',
					'display': true,
					'viewMappingsName': 'ValueStreamReportCard'
				}],
				'procurementAnalysis': [{
					'name': 'Daily Throughput Cost',
					'url': '/application/f/home.html#/supply-chain/pq-analysis/pq-by-cost/',
					'display': true,
					'viewMappingsName': 'pq-analysis/pq-by-cost'
				}, {
					'name': 'Purchased Inventory by Recommended ABC Classification',
					'url': '/application/f/home.html#/supply-chain/pq-analysis/abc-analysis/',
					'display': true,
					'viewMappingsName': 'pq-analysis/abc-analysis'
				}],
				'dataPipeline': [{
					'name': 'Status Summary',
					'url': '/application/f/home.html#/setup/data-pipeline',
					'display': true,
					'viewMappingsName': 'DataPipelineStatusSummary'
				}, {
					'name': 'Status Summary',
					'url': '/application/f/home.html#/setup/data-pipeline-leansync',
					'display': false,
					'viewMappingsName': 'DataPipelineStatusSummary'
				}],
				'updatetargets': [{
					'name': 'Update Monthly Targets',
					'url': '/application/f/home.html#/setup/update-targets',
					'display': true,
					'viewMappingsName': 'update-targets'
				}, {
					'name': 'Update Weekly Targets',
					'url': '/application/f/home.html#/setup/update-weekly-targets',
					'display': true,
					'viewMappingsName': 'update-weekly-targets'
				}],
				'projects-updatetargets': [{
					'name': 'Monthly',
					'url': '/application/f/home.html#/my-work/update-targets',
					'display': true,
					'viewMappingsName': 'update-targets'
				}, {
					'name': 'Weekly',
					'url': '/application/f/home.html#/my-work/update-weekly-targets',
					'display': true,
					'viewMappingsName': 'update-weekly-targets'
				}]
			},
			'VIEW_MAPPINGS': VIEW_MAPPINGS,
			'REPORTSETTINGSNAME_TO_VIEWTYPE': REPORTSETTINGSNAME_TO_VIEWTYPE,
			'SUPPLIER_VIEWS': SUPPLIER_VIEWS
		})
		.constant('VIEW_PROJECTS', {
			'NATIVE_COLUMNS_NAME': [
				'Name',
				'Site',
				'Last Update',
				'Area',
				'Category',
				'Stage',
				'Supplier Name',
				'Project Type',
				'Start Date',
				'Due Date',
				'Created (Days)',
				'Started (Days)',
				'Project Manager',
				'Project Sponsor',
				'ID',
				'Best Practice',
				'Target Savings',
				'Actual Savings',
				'Target Savings Annual',
				'Actual Savings Annual',
				'YTD Target Savings',
				'YTD Actual Savings',
				'Target Savings One Time',
				'Actual Savings One Time',
				'Target Savings Cost Avoidance',
				'Actual Savings Cost Avoidance',
				'Implementation Cost'
			]
		})
		.constant('WEEKLY_LOG_ITEM_FIELDS', {
			'purchasedInventory': {field: 'totalOnHandValue', type: 'Purchased'},
			'manufacturedInventory': {field: 'totalOnHandValue', type: 'Manufactured'},
			'criticalShortages':[
				{field: 'shortageItemCount', type: 'Purchased', criticalityLvlField: 'criticalityLevelCounts'},
				{field: 'criticalityLvl', type: 'Purchased'}
			],
			'criticalShortagesManufactured':[
				{field: 'shortageItemCount', type: 'Manufactured', criticalityLvlField: 'criticalityLevelCounts'},
				{field: 'criticalityLvl', type: 'Manufactured'}
			],
			'aggregateRiskScores': [
				{field: 'aggregateRiskScoreItemCount', type: 'Purchased', aggregateRiskScoreField: 'aggregateRiskScoreCounts'},
				{field: 'aggregateRiskScoreItemCount', type: 'Manufactured', aggregateRiskScoreField: 'aggregateRiskScoreCounts'}
			],
			'excessOverLeadTimeMultiple': {field: 'excessOnhandOverLTValue', type: 'Purchased'},
			'excessAndObsoleteInventory': {field: 'excessOnhandValuePositive', type: 'Purchased'},
			'excessInventory': {field: 'excessOnhandDemandedValue', type: 'Purchased'},
			'obsoleteInventory': {field: 'excessOnhandObsoleteValue', type: 'Purchased'},
			'newPurchaseReq': {field: 'newPRCount', type: 'Purchased'},
			'earlyDeliveries': {field: 'earlyDeliveriesValue', type: 'Purchased'},
			'openPOsForExcessMaterial': {field: 'excessOnOrderValuePositive', type: 'Purchased'},
			'clearToBuildPercentage': [
				{field: 'clearToBuildCount', type: 'Purchased'},
				{field: 'clearToBuildWindowTotalProductionOrderCount', type: 'Purchased'},
				{field: 'clearToBuildCount', type: 'Manufactured'},
				{field: 'clearToBuildWindowTotalProductionOrderCount', type: 'Manufactured'}
			],
			'clearToCommitPercentage': [
				{field: 'clearToCommitCount', type: 'Purchased'},
				{field: 'clearToCommitWindowTotalProductionOrderCount', type: 'Purchased'},
				{field: 'clearToCommitCount', type: 'Manufactured'},
				{field: 'clearToCommitWindowTotalProductionOrderCount', type: 'Manufactured'}
			],
			'purchaseReqToFirm': [
				{field: 'latePRCount', type: 'Purchased'},
				{field: 'latePRCountUnder7', type: 'Purchased'},
				{field: 'latePRCountUnder14', type: 'Purchased'},
				{field: 'latePRCountOver14', type: 'Purchased'},
				{field: 'latePRCount', type: 'Manufactured'},
				{field: 'latePRCountUnder7', type: 'Manufactured'},
				{field: 'latePRCountUnder14', type: 'Manufactured'},
				{field: 'latePRCountOver14', type: 'Manufactured'}
			],
			'purchaseReqCreatedInsideLeadTime': [
				{field: 'prsCreatedInsideLeadTime', type: 'Purchased'},
				{field: 'prsCreatedOutsideLeadTime', type: 'Purchased'},
				{field: 'prsCreatedInsideLeadTime', type: 'Manufactured'},
				{field: 'prsCreatedOutsideLeadTime', type: 'Manufactured'}
			],
			'ppoInsideLeadTime': [
				{field: 'latePPOCount', type: 'Manufactured'},
				{field: 'latePPOCountUnder7', type: 'Manufactured'},
				{field: 'latePPOCountUnder14', type: 'Manufactured'},
				{field: 'latePPOCountOver14', type: 'Manufactured'}
			],
			'vmiPartsUnderMin': {field: 'vmiUnderMinCount', type: 'Purchased'},
			'vmiInventoryOverMax': {field: 'onhandValueGtMinMax', type: 'Purchased'},
			'itemsUnderSafetyStock': {field: 'itemUnderSafetyStockCount', type: 'Purchased'},
			'itemsUnderSafetyStockManufactured': {field: 'itemUnderSafetyStockCount', type: 'Manufactured'},
			'ropItemsOverMax': {field: 'onhandValueGtReorderPoint', type: 'Purchased'},
			'posToCancelNext90Days': {field: 'poToCancelNext90DaysOverMin', type: 'Purchased'},
			'openPOsForObsoleteMaterial': {field: 'excessOnOrderObsoleteValue', type: 'Purchased'},
			'openPOsForExcessOverLeadTimeMultiple': {field: 'excessOnOrderOverLTValue', type: 'Purchased'},
			'daysOfInventory': [
				{field: 'totalOnHandValue', type: 'Purchased'},
				{field: 'avgInventoryLast12Months', type: 'Purchased'},
				{field: 'pastDemandValue', type: 'Purchased'},
				{field: 'futureDemandValue', type: 'Purchased'},
				{field: 'totalOnHandValue', type: 'FinishedGood'},
				{field: 'pastDemandValue', type: 'FinishedGood'},
				{field: 'futureDemandValue', type: 'FinishedGood'}
			],
			'turnsOfInventory': [
				{field: 'totalOnHandValue', type: 'Purchased'},
				{field: 'avgInventoryLast12Months', type: 'Purchased'},
				{field: 'pastDemandValue', type: 'Purchased'},
				{field: 'futureDemandValue', type: 'Purchased'}
			],
			'poBehindSchedule': [
				{field: 'latePOCount', type: 'Purchased'},
				{field: 'latePOCount', type: 'Manufactured'}
			],
			'mrpResizeOpportunity': {field: 'mrpResizingOpportunityWithDemand', type: 'Purchased'},
			'totalInventory': [
				{field: 'totalOnHandValue', type: 'Purchased'},
				{field: 'totalOnHandValue', type: 'Manufactured'},
				{field: 'finishedGoodValue', type: 'Manufactured'}
			],
			'shortagePoActions': [
				{field: 'poCountInsideReceivingTime', type: 'Purchased'},
				{field: 'poCountLateBucket1', type: 'Purchased'},
				{field: 'poCountLateBucket2', type: 'Purchased'},
				{field: 'poCountLateBucket3', type: 'Purchased'},
				{field: 'poCountLateBucket4', type: 'Purchased'}
			],
			'shortagesByOrderLines': [
				{ field: 'shortagesByOrderLines', type: 'Purchased'},
				{ field: 'shortagesByOrderLines', type: 'Manufactured'}
			],
			'indirectSpend': [
				{field: 'indirectSpend', type: 'Purchased'},
				{field: 'indirectSpend', type: 'Manufactured'}
			],
			'componentAvailabilityPercent': [
				{ field: 'componentAvailabilityItemCount', type: 'Purchased' },
				{ field: 'hasPastDueDemandIncludingTodayItemCount', type: 'Purchased' },
				{ field: 'hasPastDueDemandIncludingNext7DaysItemCount', type: 'Purchased' },
				{ field: 'componentAvailabilityItemCount', type: 'Manufactured' },
				{ field: 'hasPastDueDemandIncludingTodayItemCount', type: 'Manufactured' },
				{ field: 'hasPastDueDemandIncludingNext7DaysItemCount', type: 'Manufactured' }
			]
		})
		.constant('LEANDNA_EMAIL_SUFFIX', '@leandna.com')
		.constant('SETUP_PAGES', {
			'CUSTOMER_ADMINS': [
				'app.setup.shortage-criticality-customer',
				'app.setup.shortage-risk-score-customer',
				'app.setup.po-status-categories',
				'app.setup.customer-order-status-categories',
				'app.setup.supplier-portal-config',
				'app.setup.flex-field-config',
				'app.setup.inventoryActionsPoActionConfig',
				'app.setup.unable-to-fix-categories',
				'app.setup.project-general-customer-settings',
				'app.setup.project-saving-categories',
				'app.setup.project-custom-fields',
				'app.setup.supply-chain-settings',
				'app.setup.writeback-summary',
				'app.setup.supplier-welcome-email-editor-customer',
				'app.setup.supplier-welcome-email-editor'
			],
			'LEANDNA_CUSTOMER_ADMINS': [
				'app.setup.createFactory',
				'app.setup.cloneSettings',
				'app.setup.manageCache',
				'app.setup.email-report'
			],
			'LEANDNA_ADMINS': [
				'app.setup.customerSuccessReport',
				'app.setup.email-report'
			]
		})
	;
});
